import React, { useState } from 'react';
import { SlidersHorizontal, ChevronDown } from 'lucide-react';
export function FilterBar() {
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const filters = [{
    id: 'exclusive',
    label: 'Exclusive offers',
    type: 'toggle'
  }, {
    id: 'sale',
    label: 'On sale',
    type: 'toggle'
  }, {
    id: 'ratings',
    label: 'Ratings',
    type: 'dropdown'
  }, {
    id: 'cashback',
    label: 'Cashback %',
    type: 'dropdown'
  }, {
    id: 'price',
    label: 'Price',
    type: 'dropdown'
  }, {
    id: 'sort',
    label: 'Sort by',
    type: 'dropdown'
  }];
  return <div className="bg-white border-y border-gray-200 py-4 mb-8 sticky top-0 z-30" data-id="element-100">
      <div className="flex items-center gap-3 overflow-x-auto hide-scrollbar" data-id="element-101">
        {/* Filter Icon */}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-full hover:bg-gray-50 transition-colors flex-shrink-0" data-id="element-102">
          <SlidersHorizontal className="w-4 h-4" data-id="element-103" />
          <span className="font-medium text-sm" data-id="element-104">Filters</span>
        </button>

        {/* Filter Buttons */}
        {filters.map(filter => <button key={filter.id} onClick={() => setActiveFilter(activeFilter === filter.id ? null : filter.id)} className={`flex items-center gap-2 px-4 py-2 border rounded-full transition-colors flex-shrink-0 text-sm font-medium ${activeFilter === filter.id ? 'border-kithward-700 bg-kithward-50 text-kithward-700' : 'border-gray-300 hover:bg-gray-50 text-gray-700'}`} data-id="element-105">
            {filter.label}
            {filter.type === 'dropdown' && <ChevronDown className="w-4 h-4" data-id="element-106" />}
          </button>)}
      </div>
    </div>;
}